function O(r, e = "", t = {}, o = ".", n) {
  for (const a in r)
    if (r.hasOwnProperty(a)) {
      const f = r[a], l = e ? `${e}${o}${a}` : a;
      n && n(f) ? t[l] = f : typeof f == "object" && f !== null && !Array.isArray(f) ? O(f, l, t, o, n) : t[l] = f;
    }
  return t;
}
function h(r, e = ".", t) {
  const o = {};
  for (const [n, a] of Object.entries(r)) {
    if (t && t(n)) {
      o[n] = a;
      continue;
    }
    const f = n.split(e);
    let l = o;
    for (let c = 0; c < f.length; c++) {
      const b = c === f.length - 1, y = f[c];
      y !== void 0 && (b ? l[y] = a : ((typeof l[y] != "object" || l[y] === null) && (l[y] = {}), l = l[y]));
    }
  }
  return o;
}
function j(r = ".", e) {
  return {
    flatten: (t) => O(t, "", {}, r, e == null ? void 0 : e.skipFlatten),
    unflatten: (t) => h(t, r, e == null ? void 0 : e.skipUnflatten),
    delimiter: () => r
  };
}
export {
  O as flattenObject,
  j as flattener,
  h as unflattenObject
};
